import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'et-welcome-block',
    templateUrl: './welcome-block.component.html',
    standalone: false
})
export class WelcomeBlockComponent {

    @Output()
    public readonly welcomeBlockHidden = new EventEmitter<void>();

    public hideWelcomeBlock(): void {
        this.welcomeBlockHidden.emit();
    }
}
